(function() {
  var app, pseudoSelect, pseudo_template, template;

  
  template = "<div class=\"pseudo-select\" data-target=\"{{target}}\">\n	<div class=\"selected\">\n		<span class=\"pseudo-val\">{{selected}}</span>\n		<span class=\"icon-arrow-down\"></span>\n	</div>\n	<ul>\n		{{#each options}}\n			<li data-pseudo-option=\"{{value}}\">{{option}}</li>\n		{{/each}}\n	</ul>\n</div>";
  
 
  pseudo_template = Handlebars.compile(template);

  pseudoSelect = {
    init: function() {
      var frag, pseudo_target;
      $(".pseudo-select").remove();
      pseudo_target = 0;
      $("select").each(function() {
        var data;
        if (!$(this).attr('data-no-pseudo')) {
          data = {
            target: "pseudotarget" + pseudo_target,
            options: []
          };
          $(this).attr('data-pseudo-select', data.target);
          $(this).children('option').each(function() {
            return data.options.push({
              value: $(this).val(),
              option: $(this).text()
            });
          });
          data['selected'] = $(this).find(':selected').text();
          $(this).after(pseudo_template(data));
          pseudo_target += 1;
          return $(this).hide();
        }
      });
      $(".pseudo-select").unbind('click');
      $('.pseudo-select').click(function() {
        $('.pseudo-select').not(this).each(function() {
          $(this).children('ul').slideUp('fast');
          return $(this).children('.selected').removeClass('focus');
        });
        $(this).children('ul').slideToggle('fast');
        return $(this).children('.selected').toggleClass('focus');
      });
      $('[data-pseudo-option]').click(function() {
        var parent, target;
        parent = $(this).parent().parent();
        target = parent.data('target');
        $("select[data-pseudo-select='" + target + "']").val($(this).data('pseudo-option')).trigger('change');
        return $(parent).children('.selected').children('.pseudo-val').html($(this).html());
      });
      frag = function(e) {
        pseudoSelect = $(".pseudo-select");
        if (!pseudoSelect.is(e.target) && pseudoSelect.has(e.target).length === 0) {
          $(pseudoSelect).children('.selected').removeClass('focus');
          return $(pseudoSelect).children('ul').slideUp('fast');
        }
      };
      $(document).mousedown(function(e) {
        return frag(e);
      });
      return $(document).bind("touchend", function(e) {
        return frag(e);
      });
    }
  };
  
  $(document).on('falcon/pseudo', function(){
    pseudoSelect.init();
  });
  
  window.falcon_pseudo = pseudoSelect;  
  $(document).ready(function() {    
    var nv_timeout, set_nv_interval;
    nv_timeout = null;
    
    var bt = Math.ceil($('nav').data('nav-count')/6);
    bt = -(bt * 45);
    set_nv_interval = function()
    {     
      
        clearInterval(nv_timeout);
        $('nav').css({bottom: 0}); 
        nv_timeout = setInterval(function() {
          if (!$('nav').is(':hover'))
            $('nav').css({bottom: bt+"px"});
        }, 1500);
      
      
      
    };
    
    
    if (bt < -45)
      $('nav').css({bottom: bt+"px"});
    
    
    $(window).scroll(set_nv_interval);
    $('nav').mouseenter(set_nv_interval);
    
    $('.xshide').click(function() {
        $(this).slideUp();
    });
    
    $('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: true,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: false,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
	});
    $('.close-xs').click(function() { $('.popup-with-zoom-anim').magnificPopup('close'); });
    
    $('#xs-menu .expand').click(function(e)
    {
      var ul = $(this).parent().parent().find('ul');
      $('#xs-menu > ul > li > ul').not(ul).each(function() {$(this).slideUp();});
      $('.expand').not(this).each(function() {$(this).removeClass('show');});
      $(this).toggleClass('show');
      ul.slideToggle();
      e.preventDefault();
    });
    
    var ft_owl, pr_owl;
    ft_owl = $('#ft-owl');
    ft_owl.owlCarousel({
      itemsCustom: [[0, 1], [450, 1], [600, 1], [700, 1], [1000, 2], [1200, 2], [1400, 2], [1600, 2]],
      slideSpeed: 400,
      autoPlay: 8000,
      stopOnHover: true,
      
      afterMove: function() {
        var control;
        control = $('[data-flex1]');
        control.each(function() {
          return $(this).removeClass('selected');
        });
        return $(control[ft_owl.data('owlCarousel').currentItem]).addClass('selected');
      }
    });
    $('[data-flex1]').click(function() {
      return ft_owl.trigger('owl.goTo', $(this).data('flex1'));
    });
    $('.pin').each(function() {
      var btns, card, flex, owl_left, owl_right, _flex, _pin;
      _pin = $(this);
      _flex = $(this).find('.owl-carousel');
      _flex.owlCarousel({
        singleItem: true,
        slideSpeed: 400,
        autoHeight: true
      });
      owl_left = $(this).find('.owl-l');
      owl_left.click(function() {
        return _flex.trigger('owl.prev');
      });
      owl_right = $(this).find('.owl-r');
      owl_right.click(function() {
        return _flex.trigger('owl.next');
      });
      card = $(this).find('.card');
      flex = $(this).find('.flex');
      btns = $(this).find('.btns');
      return $(this).find('.card-toggle').click(function(e) {
        $('.pin').not(_pin).each(function() {
          return $(this).removeClass('border');
        });
        $('.card').not(card).each(function() {
          return $(this).removeClass('show');
        });
        $('.btns').not(btns).each(function() {
          return $(this).removeClass('hidden');
        });
        $('.flex').each(function() {
          return $(this).css({
            height: "auto"
          });
        });
        if (!card.hasClass('show')) {
          flex.css({
            height: "" + (card.outerHeight()) + "px"
          });
        }
        _pin.toggleClass('border');
        card.toggleClass('show');
        btns.toggleClass('hidden');
        return e.preventDefault();
      });
    });
    
    return $('.accr').accordion({
      heightStyle: "content",
      collapsible: true
    });
  });

  app = angular.module('falcon', []);

  app.directive("quantityPicker", function() {
    return {
      restrict: 'E',
      scope: {
        "default": "@",
        value: "@",
        name: "@"
      },
      template: "<div class='qty'>\n  <a class='button type2 icon-minus' ng-click='modify(-1)'></a>\n  <input type=\"text\" name=\"{{name}}\" ng-model=\"quantity\">\n  <a class='button type2 icon-plus' ng-click='modify(1)'></a>\n</div>",
      link: function(scope, element, attrs) {
        var _default;
        _default = scope["default"];
        scope.quantity = scope.value || _default;
        scope.$watch('quantity', function() {
          scope.quantity = parseInt(("" + scope.quantity).replace(/[^0-9]/g, ''));
          if (scope.quantity < _default || isNaN(scope.quantity)) {
            return scope.quantity = _default;
          }
        });
        return scope.modify = function(delta) {
          return scope.quantity += delta;
        };
      }
    };
  });
  
  Shopify.OptionSelectors.prototype.buildSelectors = function() {
  // build selectors
    for (var i = 0; i < this.product.optionNames().length; i++) {
      var sel = new Shopify.SingleOptionSelector(this, i, this.product.optionNames()[i], this.product.optionValues(i));
      sel.element.disabled = false;
      this.selectors.push(sel);
    }
  
    // replace existing selector with new selectors, new hidden input field, new hidden messageElement
    var divClass = this.selectorDivClass;
    var optionNames = this.product.optionNames();
    var elements = Shopify.map(this.selectors, function(selector) {
      var div = document.createElement('div');
      div.setAttribute('class', 'form-group');
      // create label if more than 1 option (ie: more than one drop down)
      if (optionNames.length > 1) {
        // create and appened a label into div
        var label = document.createElement('label');
        label.htmlFor = selector.element.id;
        label.innerHTML = selector.name;
        div.appendChild(label);
      }
      div.appendChild(selector.element);
      return div;
    });
  
    return elements;
  };

  $(document).ready(function() { $(document).trigger('falcon/pseudo'); });
}).call(this);